import { styled } from "../../stitches.config";
import { Box } from "../primitives";

export const ScrollStyles = {
  "&::-webkit-scrollbar": {
    width: "6px", // for vertical scrollbar
    height: "6px", // for horizontal scrollbar
  },
  "&::-webkit-scrollbar-thumb": {
    background: "$primary",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
};

export const TitleStyle = styled(Box, {
  fontSize: "20px",
  fontWeight: "bold",
  color: "#166534",
  textAlign: "center",
});

export const LabelStyled = styled("label", {
  fontWeight: "bold",
  fontSize: 10,
});

export const PrimaryButton = styled("button", {
  all: "unset",
  backgroundColor: "#166534",
  color: "white",
  width: 100,
  padding: "4px 8px",
  borderRadius: "8px",
  fontSize: "10px",
  fontWeight: 600,
  textAlign: "center",
  cursor: "pointer",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
  transition: "background 0.3s ease",
  variants: {
    isDisabled: {
      true: {
        backgroundColor: "#f3f4f6",
        color: "#9ca3af",
        cursor: "not-allowed",
        border: "2px solid #9ca3af",
        opacity: 0.6,
      },
    },
    isBig: {
      true: {
        fontSize: "14px",
        padding: "8px 16px",
      },
    },
  },
});

export const SecondaryButton = styled("button", {
  all: "unset",
  backgroundColor: "#F0FDF4",
  color: "#166534",
  width: 100,
  padding: "4px 8px",
  borderRadius: "8px",
  fontSize: "10px",
  fontWeight: 600,
  textAlign: "center",
  cursor: "pointer",
  border: "2px solid #166534",
  transition: "background 0.3s ease, color 0.3s ease",
  variants: {
    isDisabled: {
      true: {
        backgroundColor: "#f3f4f6",
        color: "#9ca3af",
        cursor: "not-allowed",
        border: "2px solid #9ca3af",
        opacity: 0.6,
      },
    },
    isBig: {
      true: {
        fontSize: "14px",
        padding: "8px 16px",
      },
    },
  },
});

export const StyledInput = styled("input", {
  border: "1px solid #d1d5db", // Light gray border
  borderRadius: "8px", // Softer rounded corners
  padding: "0.75rem 1rem", // Comfortable padding
  width: "100%",
  boxSizing: "border-box",
  fontSize: "12px",
  fontFamily: "inherit",
  outline: "none",
  transition: "border-color 0.2s, box-shadow 0.2s",
});

export const StyledSelect = styled("select", {
  border: "1px solid #d1d5db",
  borderRadius: "8px",
  padding: "5px",
  width: "100%",
  boxSizing: "border-box",
  fontSize: "12px",
  fontFamily: "inherit",
  outline: "none",
  transition: "border-color 0.2s, box-shadow 0.2s",
  pt: "2px",
  "&:focus": {
    outline: "solid 1px",
  },
});
